import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"margin-bottom":"15px"} }
const _hoisted_3 = {
  class: "announcements",
  style: {"width":"100%","padding":"0","margin-bottom":"24px"}
}
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.announcements.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              style: {"text-decoration":"none"},
              class: "my-checklists-label",
              to: "/announcements"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("Announcements", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.announcements, (an, i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, [
                _createElementVNode("div", null, [
                  _createElementVNode("i", null, _toDisplayString(an.DateDisplay) + " - " + _toDisplayString(an.Location), 1)
                ]),
                _createElementVNode("div", {
                  innerHTML: an.TextDisplay,
                  style: {"max-width":"920px"}
                }, null, 8, _hoisted_4),
                _createElementVNode("div", null, [
                  _createElementVNode("b", null, "  - " + _toDisplayString(an.CreatedBy), 1)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}